import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import ShellCard from "../../components/ShellCard";
import { locations } from "../../data/locations";
import heroBanner from "../../assets/images/page-title.jpg";

const AllLocations = () => {
  const LocationCard = ({ location }) => (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
      <div
        className="h-100 p-4 rounded"
        style={{ backgroundColor: "rgba(255, 255, 255, 0.05)" }}
      >
        <h5
          className="text-warning mb-3"
          style={{ fontSize: "0.95rem", minHeight: "3rem" }}
        >
          {location.title}
        </h5>
        {location.subtitle && (
          <p className="text-white-50 mb-2" style={{ fontSize: "0.85rem" }}>
            {location.subtitle}
          </p>
        )}
        <div className="text-white-50" style={{ fontSize: "0.9rem" }}>
          <p className="mb-2">
            {location.address}
            <br />
            {location.city}
          </p>
          <p className="mb-1">
            <strong className="text-white">Phone:</strong>{" "}
            <a
              href={`tel:${location.phone.replace(/[^0-9]/g, "")}`}
              className="text-warning text-decoration-none"
            >
              {location.phone}
            </a>
          </p>
          {location.fax && (
            <p className="mb-1">
              <strong className="text-white">Fax:</strong> {location.fax}
            </p>
          )}
          <div className="mt-3 d-flex gap-2">
            <Link
              to="/contact-us"
              className="btn btn-sm btn-outline-warning d-flex align-items-center justify-content-center"
              style={{ fontSize: "0.8rem" }}
            >
              <FontAwesomeIcon
                icon={faEnvelope}
                style={{ fontSize: "0.75rem", marginRight: "0.35rem" }}
              />
              <span>Email</span>
            </Link>
            <a
              href={location.directions}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-outline-warning d-flex align-items-center justify-content-center"
              style={{ fontSize: "0.8rem" }}
            >
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                style={{ fontSize: "0.75rem", marginRight: "0.35rem" }}
              />
              <span>Directions</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Our Locations</h1>
              <p className="banner-subheading">Find a Location Near You</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding pb-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <p className="text-warning fs-4 pt-5 mb-0">
                <a
                  href="tel:305-513-0063"
                  className="text-warning text-decoration-none"
                >
                  (305) 513-0063
                </a>
                {" - "}
                <a
                  href="tel:1-888-41-METRO"
                  className="text-warning text-decoration-none"
                >
                  1-888-41-METRO
                </a>
              </p>
            </div>
          </div>

          {/* Miami Dade County */}
          <div className="row mb-5">
            <div className="col-12">
              <ShellCard>
                <h3 className="text-warning mb-4">Miami Dade County</h3>
                <div className="row">
                  {locations.miamiDade.map((location, index) => (
                    <LocationCard key={index} location={location} />
                  ))}
                </div>
              </ShellCard>
            </div>
          </div>

          {/* Broward County */}
          <div className="row mb-5">
            <div className="col-12">
              <ShellCard>
                <h3 className="text-warning mb-4">Broward County</h3>
                <div className="row">
                  {locations.broward.map((location, index) => (
                    <LocationCard key={index} location={location} />
                  ))}
                </div>
              </ShellCard>
            </div>
          </div>

          {/* Palm Beach County */}
          <div className="row mb-5">
            <div className="col-12">
              <ShellCard>
                <h3 className="text-warning mb-4">Palm Beach County</h3>
                <div className="row">
                  {locations.palmBeach.map((location, index) => (
                    <LocationCard key={index} location={location} />
                  ))}
                </div>
              </ShellCard>
            </div>
          </div>

          {/* Central Florida */}
          <div className="row">
            <div className="col-12">
              <ShellCard>
                <h3 className="text-warning mb-4">Central Florida</h3>
                <div className="row">
                  {locations.centralFlorida.map((location, index) => (
                    <LocationCard key={index} location={location} />
                  ))}
                </div>
              </ShellCard>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllLocations;
